// @ts-ignore
import { PluginObject, VueConstructor } from 'vue';
import Card from '@/_legacy/components/Card.vue';
import Modal from '@/_legacy/components/Modal.vue';
import Loader from '@/_legacy/components/Icons/Loader.vue';
import SelectControl from '@/_legacy/components/Controls/SelectControl.vue';
import ProgressButton from '@/_legacy/components/ProgressButton.vue';
import DateTimePicker from '@/_legacy/components/DateTimePicker.vue';
import Checkbox from '@/_legacy/components/Index/Checkbox.vue';
import Icon from '@/_legacy/components/Icons/Icon.vue';
import SearchIcon from '@/_legacy/components/Icons/Search.vue';
import Delete from '@/_legacy/components/Icons/Delete.vue';
import Download from '@/_legacy/components/Icons/Download.vue';
import Edit from '@/_legacy/components/Icons/Edit.vue';
import Clone from '@/_legacy/components/Icons/Clone.vue';
import Play from '@/_legacy/components/Icons/Play.vue';
import Label from '@/_legacy/components/Form/Label.vue';
import Refresh from '@/_legacy/components/Icons/Refresh.vue';
import View from '@/_legacy/components/Icons/View.vue';
import Lock from '@/_legacy/components/Icons/Lock.vue';
import Heading from '@/_legacy/components/Heading.vue';
// @ts-ignore
import VTooltip from 'v-tooltip';
import debounce from '@/_legacy/directives/debounce';
import focus from '@/_legacy/directives/focus';
import PortalVue from 'portal-vue';
import Vuelidate from 'vuelidate';
import ToggleButton from 'vue-js-toggle-button';
import Toasted from 'vue-toasted';

// these plugins were copied from v1, review and remove after rewrite to TS
const LegacyPlugin: PluginObject<void> = {
  install(Vue: VueConstructor) {
    Vue.use(VTooltip);
    //legacy, not compatible with Vue typings
    //@ts-ignore
    Vue.use(Vuelidate);
    Vue.use(PortalVue);
    Vue.use(ToggleButton);

    Vue.use(
      Toasted,
      {
        theme: 'nova',
        position: 'bottom-center',
        duration: 6000,
      },
    );

    Vue.component('card', Card);
    Vue.component('loader', Loader);
    // eslint-disable-next-line max-len
    //Type 'VueConstructor<Vue>' is missing the following properties from type 'VueConstructor<Vue>': util, toasted, gtm, fullStory
    //legacy, not compatible with Vue typings
    //@ts-ignore
    Vue.component('modal', Modal);
    // @ts-ignore
    Vue.component('select-control', SelectControl);
    Vue.component('progress-button', ProgressButton);
    Vue.component('checkbox', Checkbox);
    Vue.component('icon', Icon);
    Vue.component('icon-delete', Delete);
    Vue.component('icon-download', Download);
    Vue.component('icon-edit', Edit);
    Vue.component('icon-clone', Clone);
    Vue.component('icon-play', Play);
    Vue.component('icon-refresh', Refresh);
    Vue.component('icon-search', SearchIcon);
    Vue.component('icon-view', View);
    Vue.component('icon-lock', Lock);
    Vue.component('form-label', Label);
    Vue.component('date-time-picker', DateTimePicker);
    Vue.component('heading', Heading);

    // @ts-ignore
    Vue.directive('debounce', debounce);
    // @ts-ignore
    Vue.directive('focus', focus);
  },
};

export default LegacyPlugin;
